export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mapbox-gl-csp-worker-2b508f22ff82d4e44b71.worker.js");
}
